import './App.css';
import { useEffect, useState } from "react";
import InfoBox from "./components/InfoBox.jsx" 
import ImagesShow from './components/ImagesShow.jsx';


function App() {
  const [data, setData] = useState({ headLine: "", infoText: "" });
  const [showImages, setShowImages] = useState(false);

  const infotextJson = `{
  "headLine": "Information:",
  "infoText": "Hier geht es sehr bald weiter.\\n\\nBitte noch etwas Geduld!\\n\\nWir arbeiten daran.\\n\\n\\n\\n"
}`
  ;

  useEffect(() => {
    document.title = "Rittergut Bikersruh";
    // fetch("/data/infotext.json")
    const infotext = JSON.parse(infotextJson);
    setData(infotext);
  }, []);

  return (
    <div className="App">
      <div className="background-section">
        {!showImages && <InfoBox headLine={data.headLine} infoText={data.infoText} onShowImages={() => setShowImages(true)}/>}
        {showImages && <ImagesShow />}
      </div>
    </div>
  );
}

//         {showImages && <ImagesShow />}

export default App;
